import React from "react";
import { Menu } from "lucide-react";

export default function Topbar({ setSidebarOpen, enrollment }) {
  return (
    <header className="flex items-center justify-between h-16 px-4 bg-white shadow">
      <div className="flex items-center">
        <button
          className="md:hidden p-2 mr-2"
          onClick={() => setSidebarOpen(true)}
        >
          <Menu className="h-5 w-5 text-blue-700" />
        </button>
        <h1 className="text-base md:text-lg font-semibold text-gray-800 truncate">
          Hostel Management System - GBU
        </h1>
      </div>
    </header>
  );
}
